import React from "react";
import { Toast } from "@prestosports/commons-ui";
import WifiOff32 from "@carbon/icons-react/lib/wifi--off/32";
import Wifi32 from "@carbon/icons-react/lib/wifi/32";
import gameMuiTheme from "../views/layout/styles/GameMuiTheme";

const { Slide, toast } = Toast;

const options = {
	position: "bottom-center",
	transition: Slide,
	autoClose: 5000,
	theme: "colored"
};

const getOptions = (uniqueId, opt = {}) => {
	return { toastId: uniqueId.replaceAll(" ", ""), ...options, ...opt };
};

class Alert {
	static success(message, opts) {
		toast.success(
			message,
			getOptions(message, {
				...opts,
				style: { backgroundColor: gameMuiTheme.palette.gameMode.ternary }
			})
		);
	}

	static error(message, opts) {
		toast.error(
			message,
			getOptions(message, {
				...opts,
				style: { backgroundColor: gameMuiTheme.palette.primary.main }
			})
		);
	}

	static info(message) {
		toast.info(message, getOptions(message));
	}

	static warn(message) {
		toast.warn(message, getOptions(message));
	}

	static sync(message, error = false) {
		if (error) {
			Alert.error(message, {
				icon: <WifiOff32 />
			});
		} else {
			Alert.success(message, {
				icon: <Wifi32 />
			});
		}
	}
}

export default Alert;
